var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "general-panel" }, [
      _c("div", { staticClass: "general-panel__heading" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("HEADING_SAMPLE_TOKENS")))]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle m-l-5",
          attrs: { "aria-hidden": "true" }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "general-panel__content form-horizontal" },
        _vm._l(_vm.selectedMacros, function(macro, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("ValidationProvider", {
                ref: `sampleToken${index}`,
                refInFor: true,
                attrs: { rules: "required", slim: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ classes }) {
                        return [
                          _c("div", { class: classes }, [
                            _c("label", { staticClass: "p-t-7" }, [
                              _vm._v(_vm._s(macro.name))
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-long-arrow-right m-l-5 m-r-5",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: macro.value,
                                  expression: "macro.value"
                                }
                              ],
                              staticClass: "form-control width-auto",
                              attrs: {
                                href: `sampleToken${index}`,
                                type: "text"
                              },
                              domProps: { value: macro.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(macro, "value", $event.target.value)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "REQUIRED",
                                  expression: "'REQUIRED'"
                                }
                              ],
                              staticClass: "form-group__label-required m-l-15"
                            })
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }